<template>
    <div class="filter" v-cloak>
        <div class="filter__header">
            <div class="top">
                <h3 class="title">Filteren</h3>
                <div class="close-filter">
                    <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" fill="none">
                        <path fill="#000"
                              d="m1.2248 13.8248-1.049995-1.05L5.9498 6.9998.174805 1.2248 1.2248.174805 6.9998 5.9498l5.775-5.774995 1.05 1.049995-5.775 5.775 5.775 5.775-1.05 1.05-5.775-5.775-5.775 5.775Z"/>
                    </svg>
                </div>
            </div>
            <div class="item-wrapper">
                <span class="title" v-if="$store.state.filterState">Actieve filters</span>
                <div class="active-filters" id="active-filters">
                    <template v-for="visibleFilter in $store.state.Filters">
                        <label v-for="value in visibleFilter.values" :for="value.name">
                            <svg xmlns="http://www.w3.org/2000/svg" width="10" height="10" fill="none">
                                <path fill="#47BBE3" d="m1.14995 9.5502-.699999-.70001L4.29995 5.0002l-3.849999-3.85.699999-.700005 3.85 3.850005 3.85-3.850005.7.700005-3.85 3.85 3.85 3.84999-.7.70001-3.85-3.85-3.85 3.85Z"/>
                            </svg>
                            {{ value.name }}
                        </label>
                    </template>
                </div>
            </div>
        </div>
        <div class="filter__wrapper">
            <filter-block v-for="localFilter in localFilters" v-bind:FilterBlock="localFilter"></filter-block>
        </div>
        <div class="filter__footer">
            <div class="button button--green button--outline close-filter">Resultaten bekijken</div>
        </div>
    </div>
</template>

<script>
    import FilterBlock from "./FilterBlock";
    import {useStore} from 'vuex';
    import {mapGetters} from "vuex";

    export default {

        data() {
            return {
                filterCategories: '',
                localFilters: [],
            }
        },

        computed: {
            ...mapGetters({
                filterTrigger: 'filterTrigger'
            }),
        },

        components: {
            'filter-block': FilterBlock
        },
        methods: {
            setFiltersInState() {
                const store = useStore();
                const filterFromEl = document.getElementById('posts').getAttribute('data-filter-categories');
                const filtersParsed = JSON.parse(filterFromEl);

                const filterFromElHidden = document.getElementById('posts').getAttribute('data-filter-categories-hidden');
                const filtersParsedHidden = JSON.parse(filterFromElHidden);

                filtersParsed.forEach((value, index) =>  {
                    let tempVal = value;
                    filtersParsedHidden.forEach((hiddenValue, hiddenIndex) =>  {
                        if (value.value == hiddenValue.value) {
                            tempVal.hidden = true;
                        } else {
                            tempVal.hidden = false;
                        }
                        filtersParsed[index] = tempVal;
                    });
                });

                // console.log(filtersParsed);

                if (typeof filtersParsed === 'object') {
                    store.commit('initializeFiltersState', filtersParsed);
                    this.localFilters = filtersParsed;
                } else {
                    console.error("No filters set in 'data-categories' attribute in #posts element");
                }
            },
        },
        created() {
            this.setFiltersInState();
        }
    }
</script>